import M from 'utils/ApiCNIG';

const PROJECTION = 'EPSG:25830';
const CENTER = [702851.1093967422, 4583909.333604186];
declare var ol;
declare var CONFIGURATIONS;

export let mapjs;
export let mapInfojs;

export const initSearchMap = () => {
	const configBase = {
		url: 'https://icearagon.aragon.es/Visor2D',
		name: 'v_ign_lineas_limite_pol,v_ign_lineas_limite_Fototeca_OverMap',
		legend: 'Límites',
		transparent: false,
		isBase: false,
		visible: true,
		format: 'image/png',
		version: '1.1.1',
	};

	const initZoom = 4.2;
	mapjs = M.map({
		container: 'searchMap',
		projection: `${PROJECTION}*m`,
		center: CENTER,
		zoom: initZoom,
		minZoom: initZoom,
		controls: ['panzoom'],
		zoomConstrains: false,
		layers: [
			new M.layer.WMS(configBase),
		],
	});

  window.mapjs = mapjs;
	mapjs.addPlugin(
		new M.plugin.IGNSearchLocator({
			maxResults: 50,
			isCollapsed: true,
			collapsible: true,
		})
	);

	mapjs.on(M.evt.CHANGE_ZOOM, () => {
		const topo = new M.layer.WMTS({
			url: 'https://gestion4-idearagon.aragon.es/geoserver/gwc/service/wmts?',
			name: 'WMTS:AragonMapa',
			legend: 'WMTS:AragonMapa',
			matrixSet: 'EPSG25830_5000',
			transparent: false,
			displayInLayerSwitcher: false,
			queryable: false,
			isBase: true,
		}, { format: 'image/jpeg' });

		const contains = mapjs.getLayers().filter((l) => l.name === 'WMTS:AragonMapa').length > 0;
		const filtered = mapjs.getLayers().filter((l) => l.url !== undefined && l.url.indexOf('https://icearagon.aragon.es/Visor2D') > -1)[0];
		if (mapjs.getExactScale() <= 2000000 && !contains) {
			if (filtered !== undefined) {
				mapjs.removeLayers(filtered);
			}

			mapjs.addLayers(topo);
			const newConfigBase = configBase;
			newConfigBase.transparent = true;
			mapjs.addLayers(new M.layer.WMS(newConfigBase));
		} else if (mapjs.getExactScale() > 2000000 && contains) {
			if (filtered !== undefined) {
				mapjs.removeLayers(filtered);
			}

			mapjs.removeLayers(topo);
			mapjs.addLayers(new M.layer.WMS(configBase));
		}
	});
};

export const initInfoMap = (layerName, layerLegend, layerUrl, geom) => {
	let initZoom = 5.8;
	if (window.innerHeight <= 907 && window.innerHeight >= 703) {
		initZoom = 5.4;
	} else if (window.innerHeight <= 702 && window.innerHeight > 620) {
		initZoom = 5.2;
	} else if (window.innerHeight <= 620 && window.innerHeight > 550) {
		initZoom = 5;
	} else if (window.innerHeight <= 550 && window.innerHeight > 485) {
		initZoom = 4.8;
	} else if (window.innerHeight <= 485 && window.innerHeight >= 485) {
		initZoom = 4.6;
	}

	mapInfojs = M.map({
		container: 'infoMap',
		projection: `${PROJECTION}*m`,
		center: CENTER,
		zoom: initZoom,
		minZoom: initZoom,
		zoomConstrains: false,
	});

  window.mapInfojs = mapInfojs;

  mapInfojs.getMapImpl().once('postrender', (evt) => {
    mapInfojs.removeControls('panzoom');
  });

	mapInfojs.addPlugin(
		new M.plugin.ZoomPanel({
			position: 'TL',
			collapsed: true,
			collapsible: true,
			center: CENTER,
			zoom: initZoom,
		})
	);

	mapInfojs.addPlugin(
		new M.plugin.Rescale({
			collapsible: true,
			collapsed: true,
			position: 'BL',
			tooltip: 'Cambiar escala',
		})
	);

	mapInfojs.addPlugin(
		new M.plugin.MeasureBar({
			position: 'TL',
			collapsible: true,
			collapsed: true,
			tooltip: 'Medidas',
		})
	);

	mapInfojs.addPlugin(new M.plugin.MouseSRS({
    tooltip: 'Coordenadas',
    srs: 'EPSG:25830',
    label: 'EPSG:25830',
    precision: 4,
    geoDecimalDigits: 5,
    utmDecimalDigits: 2,
  }));

	mapInfojs.addPlugin(new M.plugin.FullTOC({
		collapsed: true,
		position: 'TR',
		https: true,
		http: true,
		codsi: false,
		order: 12,
	}));

	mapInfojs.addPlugin(new M.plugin.BackImgLayer(getBackImgLayerConfiguration()));
	setTimeout(() => {
		addWMSLayer(layerName, layerLegend, layerUrl, '1.3.0', true, { displayInLayerSwitcher: true, visibility: true, zIndex: 9999 });
		mapInfojs.setBbox(getExtentByCoordinates(geom));
	}, 100);
};

export const setInitView = () => {
	mapjs.setCenter(CENTER);
	mapjs.removeControls('panzoom');
	mapjs.setZoom(4.2);
	let layerRes = mapjs.getLayers().filter((layer) => (layer.name.startsWith('searchresult') && layer.type === 'GeoJSON'));
  if (layerRes && layerRes.length > 0) {
    mapjs.removeLayers(layerRes);
  }

	const btn = document.querySelector('#searchMap > div > div.ol-overlaycontainer-stopevent > div > div.m-area.m-top.m-left > div.m-panel.ign-searchlocator-panel.opened > button');
	if (btn !== null) {
		btn.click();
	}

	mapjs.addControls('panzoom');
}

export const getZoom = () => {
  return mapjs.getZoom();
}

export const getBbox = () => {
  const bbox = mapjs.getBbox();
  return [bbox.x.min, bbox.y.min, bbox.x.max, bbox.y.max];
}

export const extentIntersectsBbox = (extent) => {
  return ol.extent.intersects(getBbox(), extent);
}

export const getExtentByCoordinates = (geometry) => {
  let extent = [];
  if (geometry.type === 'Polygon') {
    extent = ol.proj.transformExtent(new ol.geom.Polygon(geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
  } else {
    extent = ol.proj.transformExtent(new ol.geom.MultiPolygon(geometry.coordinates).getExtent(), 'EPSG:4326', PROJECTION);
  }

  return extent;
}

export const addWMSLayer = (name, legend, url, version, tiled, options) => {
  const args = {
    name: name,
    url: url,
    legend: legend,
    transparent: true,
    tiled: tiled,
    version: version,
  };

  const layer = new M.layer.WMS(args, options);
  if (options && options.hasOwnProperty('visibility')) {
    layer.setVisible(options.visibility);
  }

  if (options && options.hasOwnProperty('displayInLayerSwitcher')) {
    layer.displayInLayerSwitcher = options.displayInLayerSwitcher;
  }

  if (options && options.hasOwnProperty('zIndex')) {
    layer.setZIndex(options.zIndex);
  }

  mapInfojs.addLayers(layer);
  return layer.getImpl().getExtent();
};

export const newGeoJSONLayer = (args, options) => {
  return new M.layer.GeoJSON(args, options || {});
}

export const getBackImgLayerConfiguration = (t) => {
	return {
		position: 'TR',
		collapsible: true,
		collapsed: true,
		layerId: 0,
		layerVisibility: true,
		columnsNumber: 5,
		layerOpts: [
			{
        id: 'topografico',
        preview: '/catalogocartoteca/img/layers/topo.png',
        title: 'Topográfico',
        layers: [
          new M.layer.WMTS({
            url: 'https://gestion4-idearagon.aragon.es/geoserver/gwc/service/wmts?',
            name: 'WMTS:AragonMapa',
            legend: 'WMTS:AragonMapa',
            matrixSet: 'EPSG25830_5000',
            transparent: false,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            format: 'image/jpeg',
          }),
					new M.layer.WMS({
            url: 'https://icearagon.aragon.es/Visor2D',
            name: 'v_ign_lineas_limite_pol',
            legend: 'Lineas Limite',
            transparent: true,
            visible: true,
            format: 'image/png',
            version: '1.1.1',
						displayInLayerSwitcher: false,
          }),
        ],
      },
			{
        id: 'ortofoto',
        preview: '/catalogocartoteca/img/layers/ortofoto.png',
        title: 'Ortofoto',
        layers: [
          new M.layer.WMTS({
            url: 'https://gestion4-idearagon.aragon.es/geoserver/gwc/service/wmts?',
            name: 'WMTS:AragonFoto',
            legend: 'WMTS:AragonFoto',
            matrixSet: 'EPSG25830_5000',
            transparent: false,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            format: 'image/jpeg',
          }),
					new M.layer.WMS({
            url: 'https://icearagon.aragon.es/Visor2D',
            name: 'AraFon,Exonimos,v_ign_lineas_limite_pol,v101e_municipios_fotcar',
            legend: 'Límites y exónimos',
            transparent: true,
            visible: true,
						tiled: false,
            format: 'image/png',
            version: '1.1.1',
						displayInLayerSwitcher: false,
          }),
        ],
      },
			{
        id: 'osm',
        preview: '/catalogocartoteca/img/layers/osm.png',
        title: 'OpenStreetMap',
        layers: [
					new M.layer.OSM({
            name: 'osm',
            legend: 'OpenStreetMap',
            transparent: false,
						isBase: true,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
          }),
					new M.layer.WMS({
            url: 'https://icearagon.aragon.es/Visor2D',
            name: 'v_ign_lineas_limite_pol',
            legend: 'Lineas Limite',
            transparent: true,
            visible: true,
            format: 'image/png',
            version: '1.1.1',
						displayInLayerSwitcher: false,
          }),
        ],
      },
			{
        id: 'mdt',
        preview: '/catalogocartoteca/img/layers/mdt.png',
        title: 'MDT Sombreado',
        layers: [
					new M.layer.WMS({
            url: 'https://wmspro-idearagon.aragon.es/erdas-iws/ogc/wms/Modelos?',
            name: 'LiDAR_som_1m_2016_2021',
            legend: 'LiDAR_som_1m_2016_2021',
            transparent: true,
            visible: true,
						tiled: true,
            format: 'image/jpeg',
            version: '1.3.0',
						displayInLayerSwitcher: false,
          }),
					new M.layer.WMS({
            url: 'https://icearagon.aragon.es/Visor2D',
            name: 'AraFon,Exonimos,v_ign_lineas_limite_pol,v101e_municipios_fotcar',
            legend: 'Límites y exónimos',
            transparent: true,
            visible: true,
						tiled: false,
            format: 'image/png',
            version: '1.1.1',
						displayInLayerSwitcher: false,
          }),
        ],
      },
			{
        id: 'siose',
        preview: '/catalogocartoteca/img/layers/siose.png',
        title: 'Siose',
        layers: [
					new M.layer.WMTS({
            url: 'https://idearagon.aragon.es/geoserver/gwc/service/wmts?',
            name: 'WMTS:Siose_cobertura_2017',
            legend: 'WMTS:Siose_cobertura_2017',
            matrixSet: 'EPSG25830_10000',
            transparent: false,
            displayInLayerSwitcher: false,
            queryable: false,
            visible: true,
            format: 'image/jpeg',
          }),
					new M.layer.WMS({
            url: 'https://icearagon.aragon.es/Visor2D',
            name: 'v_ign_lineas_limite_pol',
            legend: 'Lineas Limite',
            transparent: true,
            visible: true,
            format: 'image/png',
            version: '1.1.1',
						displayInLayerSwitcher: false,
          }),
        ],
      },
		],
	};
}
